import initGrabScroll from './initGrabScroll';

const setupCustomerReviews = (root) => {
	const carousel = root.querySelector('[data-customer-reviews-carousel]');
	if (!carousel) return;

	initGrabScroll(root);

	const cards = Array.from(carousel.querySelectorAll('.customer-review-card'));
	const dots = Array.from(root.querySelectorAll('[data-customer-reviews-dot]'));
	const prev = root.querySelector('[data-customer-reviews-prev]');
	const next = root.querySelector('[data-customer-reviews-next]');

	if (!cards.length) return;

	const getGap = () =>
		parseInt(window.getComputedStyle(carousel).columnGap, 10) ||
		parseInt(window.getComputedStyle(carousel).gap, 10) ||
		24;

	const getCardScrollAmount = () => cards[0].offsetWidth + getGap();

	const getActiveIndex = () => {
		const amount = getCardScrollAmount();
		if (!amount) return 0;
		return Math.min(
			cards.length - 1,
			Math.max(0, Math.round(carousel.scrollLeft / amount)),
		);
	};

	const updateControls = () => {
		const activeIndex = getActiveIndex();
		const isAtStart = carousel.scrollLeft <= 1;
		const isAtEnd =
			carousel.scrollLeft + carousel.clientWidth + 1 >= carousel.scrollWidth;

		dots.forEach((dot, index) => {
			dot.classList.toggle('is-active', index === activeIndex);
		});

		if (prev) prev.classList.toggle('opacity-30', isAtStart);
		if (next) next.classList.toggle('opacity-30', isAtEnd);
	};

	const scrollToIndex = (index) => {
		const target = Math.min(cards.length - 1, Math.max(0, index));
		carousel.scrollTo({
			left: target * getCardScrollAmount(),
			behavior: 'smooth',
		});
	};

	prev?.addEventListener('click', () => {
		scrollToIndex(getActiveIndex() - 1);
	});

	next?.addEventListener('click', () => {
		scrollToIndex(getActiveIndex() + 1);
	});

	dots.forEach((dot) => {
		dot.addEventListener('click', () => {
			const index = Number(dot.dataset.index);
			if (Number.isNaN(index)) return;
			scrollToIndex(index);
		});
	});

	carousel.addEventListener('scroll', updateControls, { passive: true });
	window.addEventListener('resize', updateControls);
	updateControls();
};

const initCustomerReviews = () => {
	document.querySelectorAll('.customer-reviews').forEach(setupCustomerReviews);
};

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initCustomerReviews);
} else {
	initCustomerReviews();
}
